
import React, { useState } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { CiEdit } from "react-icons/ci";
import { IoIosSave } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";

export default function FinListNakalaKafla({
  token,
  titles = [],
  list = [],
  loading,
  updateData,
}) {
  const [editingIndex, setEditingIndex] = React.useState();
  const [inputValue, setInputValue] = React.useState();
  const [searchWords, setSearchWords] = useState([]);

  const dispatch = useDispatch();
  // list.border_number
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    console.log(event.target.value);
  };

  // let filterData = list?.data.filter(
  //   (data) => (data.nakala_status = "Payment Pending")
  // );

  // console.log("data......log seen here", filterData);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const apiCall = () => {
    updateData("123654");
  };

  const update = async (url, type) => {
    try {
      const res = await nodeinstance.post(url, type, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        apiCall();
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  //edit text Field
  const handleEdit = (index, initialValue) => {
    setEditingIndex(index);
    setInputValue(initialValue);
  };
  return (
    <>
      <div className="flex flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <Search
          searchKey={[
            "employee_id",
            "name",
            "client_name",
            "visa_provider",
            "iqama_number",
            "passport_number",
            "actual_visa_profession",
          ]}
          setSearchWords={setSearchWords}
        />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
      <CountPerPage />
      <div
        className={`grid grid-cols-table-fin-nakala auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((t, index) => (
          <p key={index} className="font-semibold uppercase">
            {t}
          </p>
        ))}
        {list?.isLoading && <LoadingWithLable className="col-span-6" />}
        {!list?.isLoading && <NoDataFound />}

        {!list?.isLoading
          ? currentList
              ?.filter((data) => data.nakala_status === "Payment Pending")
              .map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_id || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.client_name || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.visa_provider || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_number || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.passport_number || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.actual_visa_profession || "-"}
                    />
                  </p>
                  {/* <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.current_profession_level || "-"}
                    />
                  </p> */}
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.application_date || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.new_visa_provider || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.change_fee || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.borne_by || "-"}
                    />
                  </p>
                  <div className="flex flex-row">
                    <p>
                      {editingIndex === index ? (
                        // <input
                        //   type="number"
                        //   step={"0.01"}
                        //   className="input input-sm input-bordered"
                        //   required
                        //   pattern="[0-9]*"
                        //   min={10}
                        //   onChange={(e) => handleInputChange(e)}
                        // />
                        <input
                          type="number"
                          step="0.01"
                          className="input input-sm input-bordered"
                          required
                          pattern="[0-9]*"
                          min={10}
                          value={inputValue ? inputValue : list.fees}
                          onChange={(e) => handleInputChange(e)}
                          style={{
                            width: "100px",
                            fontSize: "0.875rem",
                            padding: "0.25rem 0.5rem",
                          }} // Add inline styles to reduce the size
                        />
                      ) : (
                        <p>
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={
                              list.fees != ""
                                ? list.fees
                                : list.change_fee || "-"
                            }
                          />
                        </p>
                      )}
                    </p>
                    <button
                      className={
                        list.nakala_status === "Payment Pending"
                          ? "p-1 px-2 rounded-md text-white text-xs"
                          : "p-1 px-2 rounded-md text-white text-xs "
                      }
                      disabled={
                        list.nakala_status === "Payment Pending" ? false : true
                      }
                      onClick={() => {
                        if (editingIndex === index) {
                          setEditingIndex(-1);
                          update("/nakal-kafala/updateFees", {
                            employee_id: list.employee_id,
                            fees: inputValue ?? list.change_fee,
                          });
                        } else {
                          setInputValue(list.fees);
                          handleEdit(index, list.fees);
                        }
                      }}
                    >
                      {editingIndex === index ? (
                        <IoIosSave size={"1.4rem"} color="green" />
                      ) : (
                        <CiEdit size={"1.4rem"} color="black" />
                      )}
                    </button>
                  </div>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.sub_segment || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.nakala_status || "-"}
                    />
                  </p>
                  {
                    <button
                      className={
                        list.nakala_status === "Payment Done"
                          ? "p-1 bg-red px-2 rounded-md text-white text-xs p-2 w-40"
                          : "p-1 px-2 rounded-md text-white text-xs p-2 w-40 bg-red "
                      }
                      // disabled={
                      //   list.nakala_status === "Payment Done" ? false : true
                      // }
                      onClick={() => {
                        update("/nakal-kafala/updatePayment/", {
                          employee_id: list.employee_id,
                          status: "Payment Done",
                        });
                      }}
                    >
                      {list.nakala_status === "Pending"
                        ? "Update status To Payment Done"
                        : "Payment Done"}
                    </button>
                  }
                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </React.Fragment>
              ))
          : ""}
      </div>
      <Pagination />
    </>
  );
}
